import { editNotificationPopup } from '../commons/data-qa';

export const notificationMethods = [
  {
    text: 'EMAIL',
    value: 'EMAIL',
    dataQa: editNotificationPopup?.methodEmailBtn
  },
  {
    text: 'POST',
    value: 'POST',
    dataQa: editNotificationPopup?.methodPostBtn
  },
  {
    text: 'GET',
    value: 'GET',
    dataQa: editNotificationPopup?.methodGetBtn
  }
];
